import React, { Component } from "react";
import { withRouter } from "../../withRouter";
import cookie from "react-cookies";

class Logout extends Component {
  componentDidMount() {
    const loginType = this.props.params?.LoginType || "";

    // clear cookies
    cookie.remove("loginName", { path: "/" });
    cookie.remove("accessToken", { path: "/" });
    cookie.remove("loginID", { path: "/" });
    cookie.remove("clientAccessToken", { path: "/" });
    cookie.remove("clientID", { path: "/" });
    cookie.remove("clientFirstName", { path: "/" });
    cookie.remove("clientAllowOutlet", { path: "/" });
    cookie.remove("clientTimeFormat", { path: "/" });
    cookie.remove("clientDateFormat", { path: "/" });
    cookie.remove("clientLoginType", { path: "/" });
    cookie.remove("clientCurrency", { path: "/" });
    cookie.remove("companyID", { path: "/" });
    cookie.remove("clientCurrency", { path: "/" });
    cookie.remove("clientPerPage", { path: "/" });
    cookie.remove("clientUnquieID", { path: "/" });
    cookie.remove("companyAllowAssignVoucher", { path: "/" });
    cookie.remove("enableEmailCampaign", { path: "/" });
    cookie.remove("enableSMSCampaign", { path: "/" });
    cookie.remove("companyEnableWhatsappCampaign", { path: "/" });
    cookie.remove("companyEnableSpinWheel", { path: "/" });
    cookie.remove("companyPlans", { path: "/" });
    cookie.remove("companyEnableTimeSlotDateBased", { path: "/" });

    cookie.remove("totalOrder", { path: "/" });

    cookie.remove("companysupabaseEngagev1Password", { path: "/" });
    cookie.remove("companysupabaseEngagev1UserName", { path: "/" });
    cookie.remove("companyEnableEpicEngagev1", { path: "/" });
    cookie.remove("companysupabaseEngagePassword", { path: "/" });
    cookie.remove("companysupabaseEngageUserName", { path: "/" });
    cookie.remove("companyEnableEpicEngage", { path: "/" });
    cookie.remove("companyEnableReservation", { path: "/" });
    cookie.remove("companysupabaseReservationPassword", { path: "/" });
    cookie.remove("companysupabaseReservationUserName", { path: "/" });
    cookie.remove("loginenagev1", { path: "/" });

    localStorage.removeItem(`sb-${process.env.REACT_APP_SUPABASE_PROJECT_ID}-auth-token`);
    localStorage.removeItem(`sb-${process.env.REACT_APP_EMAIL_SUPABASE_PROJECT_ID}-auth-token`);
    localStorage.removeItem(`sb-${process.env.REACT_APP_SUPABASE_ENGAGEV1_PROJECT_ID}-auth-token`);
    localStorage.removeItem(`sb-${process.env.REACT_APP_RESERVATION_SUPABASE_PROJECT_ID}-auth-token`);
    localStorage.removeItem(`sb-${process.env.REACT_APP_CATERING_SUPABASE_PROJECT_ID}-auth-token`);

    // redirect
    this.redirectPath = loginType === "master" ? "/masterpanel" : "/";
    setTimeout(() => {
      if (loginType === "master") {
        this.props.navigate("/masterpanel", { replace: true });
      } else {
        this.props.navigate("/", { replace: true });
      }
    }, 0);
  }

  render() {
    return (
      <div>
        <h1 className="loading-text">Logging out...</h1>
      </div>
    );
  }
}

export default withRouter(Logout);
